{
  "name": "@oclif/core",
  "description": "base library for oclif CLIs",
  "version": "3.26.5",
  "author": "Salesforce",
  "bugs": "https://github.com/oclif/core/issues",
  "dependencies": {
    "@types/cli-progress": "^3.11.5",
    "ansi-escapes": "^4.3.2",
    "ansi-styles": "^4.3.0",
    "cardinal": "^2.1.1",
    "chalk": "^4.1.2",
    "clean-stack": "^3.0.1",
    "cli-progress": "^3.12.0",
    "color": "^4.2.3",
    "debug": "^4.3.4",
    "ejs": "^3.1.10",
    "get-package-type": "^0.1.0",
    "globby": "^11.1.0",
    "hyperlinker": "^1.0.0",
    "indent-string": "^4.0.0",
    "is-wsl": "^2.2.0",
    "js-yaml": "^3.14.1",
    "minimatch": "^9.0.4",
    "natural-orderby": "^2.0.3",
    "object-treeify": "^1.1.33",
    "password-prompt": "^1.1.3",
    "slice-ansi": "^4.0.0",
    "string-width": "^4.2.3",
    "strip-ansi": "^6.0.1",
    "supports-color": "^8.1.1",
    "supports-hyperlinks": "^2.2.0",
    "widest-line": "^3.1.0",
    "wordwrap": "^1.0.0",
    "wrap-ansi": "^7.0.0"
  },
  "devDependencies": {
    "@commitlint/config-conventional": "^17.8.1",
    "@oclif/plugin-help": "^6",
    "@oclif/plugin-plugins": "^4",
    "@oclif/prettier-config": "^0.2.1",
    "@oclif/test": "^3.2.11",
    "@types/ansi-styles": "^3.2.1",
    "@types/benchmark": "^2.1.5",
    "@types/chai": "^4.3.11",
    "@types/chai-as-promised": "^7.1.8",
    "@types/clean-stack": "^2.1.1",
    "@types/color": "^3.0.6",
    "@types/debug": "^4.1.10",
    "@types/ejs": "^3.1.5",
    "@types/indent-string": "^4.0.1",
    "@types/js-yaml": "^3.12.7",
    "@types/mocha": "^10.0.6",
    "@types/node": "^18",
    "@types/node-notifier": "^8.0.5",
    "@types/pnpapi": "^0.0.5",
    "@types/slice-ansi": "^4.0.0",
    "@types/strip-ansi": "^5.2.1",
    "@types/supports-color": "^8.1.1",
    "@types/wordwrap": "^1.0.3",
    "@types/wrap-ansi": "^3.0.0",
    "benchmark": "^2.1.4",
    "chai": "^4.4.1",
    "chai-as-promised": "^7.1.1",
    "commitlint": "^17.8.1",
    "cross-env": "^7.0.3",
    "eslint": "^8.57.0",
    "eslint-config-oclif": "^5.1.3",
    "eslint-config-oclif-typescript": "^3.1.6",
    "eslint-config-prettier": "^9.1.0",
    "fancy-test": "^3.0.14",
    "globby": "^11.1.0",
    "husky": "^8",
    "lint-staged": "^14.0.1",
    "madge": "^6.1.0",
    "mocha": "^10.4.0",
    "nyc": "^15.1.0",
    "prettier": "^3.2.5",
    "shx": "^0.3.4",
    "sinon": "^16.1.3",
    "ts-node": "^10.9.2",
    "tsd": "^0.31.0",
    "typescript": "^5"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "files": [
    "/lib",
    "/flush.js",
    "/flush.d.ts",
    "/handle.js"
  ],
  "homepage": "https://github.com/oclif/core",
  "keywords": [
    "oclif",
    "cli",
    "command",
    "command line",
    "parser",
    "args",
    "argv"
  ],
  "license": "MIT",
  "main": "./lib/index.js",
  "repository": "oclif/core",
  "oclif": {
    "bin": "oclif",
    "devPlugins": [
      "@oclif/plugin-help",
      "@oclif/plugin-plugins"
    ]
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "shx rm -rf lib && tsc",
    "commitlint": "commitlint",
    "compile": "tsc",
    "format": "prettier --write \"+(src|test)/**/*.+(ts|js|json)\"",
    "lint": "eslint . --ext .ts",
    "posttest": "yarn lint && yarn test:circular-deps",
    "prepack": "yarn run build",
    "prepare": "husky install",
    "pretest": "yarn build && tsc -p test --noEmit --skipLibCheck",
    "test:circular-deps": "madge lib/ -c",
    "test:debug": "nyc mocha --debug-brk --inspect \"test/**/*.test.ts\"",
    "test:integration": "mocha --forbid-only \"test/**/*.integration.ts\" --parallel --timeout 1200000",
    "test:interoperability": "cross-env DEBUG=integration:* ts-node test/integration/interop.ts",
    "test:perf": "ts-node test/perf/parser.perf.ts",
    "test": "nyc mocha --forbid-only \"test/**/*.test.ts\""
  },
  "types": "lib/index.d.ts"
}
